// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"tableWrapper--231tx","actions":"actions--2Ahef"};